import fetch, { queryString, doGet, doPost } from '../../tools/axios'

export default {
  getFestivalDetail (id) {
    return doGet(`/festival/festivals/${id}`)
  },
  // 获取某个节日的数据
  getFestivalRecordList ({ festivalId, page, perPage, sort, keyword, randomSeed, userId, toUserId }) {
    const search = queryString({ festival_id: festivalId, page, perPage, sort, keyword, random_seed: randomSeed, user_id: userId, to_user_id: toUserId })
    return doGet(`/festival/records${search}`)
  },
  // 对节日某参与者投票
  voteUp (id, cb) {
    return fetch('post', `/festival/records/${id}/vote_up`, {}, cb)
  },
  getFestivalRecordVotes (id, page, perPage) {
    return doGet(`/festival/records/${id}/votes?page=${page}&perPage=${perPage}`)
  },
  viewFestival (id) {
    return doPost(`/festival/festivals/${id}/view`)
  },
  getMyFestivalVoteInfo (id) {
    return doGet(`/festival/festivals/${id}/myVotes`)
  },
  getFestivalRecordDetail (recordId) {
    return doGet(`/festival/records/${recordId}`)
  },
  addFestivalRecord (data) {
    return doPost('/festival/records', data)
  },
  getFestivalEarthDayInfo (festivalId) {
    return doGet(`/festival/earth-day?festival_id=${festivalId}`)
  }
}
